var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgImport(props) {
  const _id4 = useUniqueInlineId();
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "99.063%",
    x2: "50%",
    y2: "0%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "99.063%",
    x2: "50%",
    y2: "0%",
    id: _id2
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9",
    offset: "0%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "99.063%",
    x2: "50%",
    y2: "0%",
    id: _id3
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9",
    offset: "0%"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: ".377%",
    x2: "50%",
    y2: "100%",
    id: _id4
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17C868",
    offset: ".019%"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62BD00",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 42.692V2.789A2.788 2.788 0 012.78 0h23.227a2.788 2.788 0 012.779 2.79v39.902H0zm26.929-1.857V2.789a.928.928 0 00-.922-.932H2.778a.928.928 0 00-.922.932v38.046H26.93z",
    fill: "url(#".concat(_id, ")"),
    transform: "translate(5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.006 52H2.78A2.786 2.786 0 010 49.214v-8.357h28.786v8.357A2.786 2.786 0 0126.006 52zM1.857 42.714v6.5c0 .521.405.929.922.929h23.227a.926.926 0 00.923-.929v-6.5H1.857z",
    fill: "url(#".concat(_id2, ")"),
    transform: "translate(5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.857 49.214a2.79 2.79 0 01-2.786-2.785 2.79 2.79 0 012.786-2.786 2.79 2.79 0 012.786 2.786 2.79 2.79 0 01-2.786 2.785zm0-3.714a.93.93 0 00-.928.929.93.93 0 00.928.928.93.93 0 00.929-.928.93.93 0 00-.929-.929z",
    fill: "url(#".concat(_id3, ")"),
    transform: "translate(5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M29 18h9v18h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.535 44.909c-.301 0-.602-.111-.837-.332l-8.826-8.279a1.22 1.22 0 011.674-1.776l6.764 6.335c-1.488-6.991-2.232-12.256-2.232-15.796 0-3.49.744-8.77 2.232-15.84a1.22 1.22 0 012.44 0c-1.488 6.978-2.232 12.19-2.232 15.635 0 3.587.744 8.924 2.232 16.01l6.776-6.344a1.22 1.22 0 011.674 1.776l-8.828 8.279c-.235.22-.536.332-.837.332z",
    fill: "url(#".concat(_id4, ")"),
    fillRule: "nonzero",
    transform: "rotate(120 29.536 26.454)"
  })));
}
export default SvgImport;